import { render, staticRenderFns } from "./gzzoc-model-basic.vue?vue&type=template&id=56a1daa6&scoped=true&lang=pug&"
import script from "./gzzoc-model-basic.vue?vue&type=script&lang=js&"
export * from "./gzzoc-model-basic.vue?vue&type=script&lang=js&"
import style0 from "./gzzoc-model-basic.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./gzzoc-model-basic.vue?vue&type=style&index=1&id=56a1daa6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a1daa6",
  null
  
)

export default component.exports